<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <BaseForm
      :action="
        () => {
          return handleSubmit(submitAction);
        }
      "
      v-slot="formProps"
      class="grid gap-4"
    >
      <ValidationProvider rules="required" name="content" tag="div" vid="content">
        <template #default="{ errors, failed }">
          <BaseFormGroup>
            <BaseFormLabel>Content</BaseFormLabel>
            <BaseFormTextarea
              v-model="formData.content"
              rows="15"
              :disabled="formProps.isPending"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </template>
      </ValidationProvider>

      <div class="grid grid-flow-col gap-2 justify-start">
        <BaseButton primary :disabled="invalid || formProps.isPending || formProps.isRejected">
          Create
        </BaseButton>
      </div>
    </BaseForm>
  </ValidationObserver>
</template>

<script>
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],
  props: {
    submit: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        content: '',
      },
    };
  },
  methods: {
    resetForm() {
      this.formData.content = '';
    },
    async submitAction() {
      try {
        await this.submit(this.formData);

        this.resetForm();

        return Promise.resolve();
      } catch (error) {
        if (error?.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.observer = this.$refs.observer;
          this.addServerErrors(error.data.errors);
        }

        return Promise.reject(error);
      }
    },
  },
};
</script>
